module.exports = __webpack_public_path__ + "img/Lexikan_500px_Putih.3fda0ec8.png";